import { Column, Row } from "components/Layout/Grid";
import SacScoreBar from "components/SacScoreBar";
import Text from "components/Text";
import React from "react";
import itemsWonIcon from "img/arrow-up-mp.svg";
import itemsLostIcon from "img/arrow-down-mp.svg";
import itemsPendingIcon from "img/pending-mp.svg";

interface ItemRateProps {
  answeredQuotations: number;
  totalAnsweredItems: number;
  titleCard: string;
  typeCard: "won" | "lost" | "pending";
  onClick?: () => void;
}

export const ItemRate: React.FC<ItemRateProps> = ({
  titleCard,
  answeredQuotations,
  totalAnsweredItems,
  typeCard = "won",
  onClick,
}) => {
  const icon =
    typeCard === "won"
      ? itemsWonIcon
      : typeCard === "pending"
      ? itemsPendingIcon
      : itemsLostIcon;
  const title =
    typeCard === "won"
      ? "Itens Ganhos"
      : typeCard === "pending"
      ? "Itens Pendentes"
      : "Itens Perdidos";
  const subtitle =
    typeCard === "won"
      ? "itens ganhos de"
      : typeCard === "pending"
      ? "itens pendentes de"
      : "itens perdidos de";
  const colorValueResponseRate =
    typeCard === "won" ? "#14A86B" : typeCard === "pending" ? "#F5A623" : "#E02828";
  
  const responseRate = totalAnsweredItems > 0 ? Number(((answeredQuotations / totalAnsweredItems) * 100).toFixed(0)) : 0;
  
  const content = (
    <>
      <Row className="pt-md-0 flex-lg-column mt-3">
        <Column className="w-100 w-lg-100 px-3 bg-white pl-sm-3 pl-md-3 pl-lg-3 dashboard-panel height-500 py-1 pb-4">
          <Row className="pt-md-0 flex-lg-column mt-3">
            <Column className="mb-3">
              <img
                className="mr-1"
                src={icon}
                alt={title}
                width={28}
                height={28}
              />
            </Column>
            <Column className="w-100 w-lg-100">
              <Text size={24} className="font-bold color-primary">
                {titleCard}: <span style={{ color: colorValueResponseRate }}>{responseRate}%</span>
              </Text>
            </Column>
          </Row>
          <SacScoreBar score={responseRate} />
          <Column className="w-100 w-lg-100 mt-3">
            <Text size={20} className="color-blue-gray text-left">
              <span className="font-bold">{answeredQuotations}</span> {subtitle} <span className="font-bold">{totalAnsweredItems}</span>{" "}
              itens respondidos
            </Text>
          </Column>
        </Column>
      </Row>
    </>
  );

  if (onClick) {
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
        style={{ cursor: "pointer" }}
      >
        {content}
      </div>
    );
  }

  return content;
};

export default ItemRate;
